import { api } from "./api";

// Member lookup accepts either phone (E.164) or cmr_id as the key.
const memberKey = (params) => params.key || params.phone_e164 || params.customerId;

export const loyaltyConfigGetApi = () => api.get(`/loyalty/config`);
export const loyaltyConfigUpdateApi = (params) =>
  api.post(`/loyalty/config`, JSON.stringify(params));

export const loyaltyMemberGetApi = (params) =>
  api.get(`/loyalty/members/${encodeURIComponent(memberKey(params))}`);

export const loyaltyExpiryRowsApi = (params) =>
  api.get(
    `/loyalty/members/${encodeURIComponent(memberKey(params))}/expiry-rows`,
    { params: { limit: params.limit || 50, offset: params.offset || 0 } }
  );

export const loyaltyRedeemPreviewApi = (params) =>
  api.get(
    `/loyalty/members/${encodeURIComponent(memberKey(params))}/redeem-preview`,
    { params: { bill_total: params.bill_total, points: params.points } }
  );

// OTP — request / verify / status.
export const loyaltyOtpRequestApi = (params) =>
  api.post(`/loyalty/redeem-otp/request`, JSON.stringify(params));

export const loyaltyOtpVerifyApi = (params) =>
  api.post(`/loyalty/redeem-otp/verify`, JSON.stringify(params));

export const loyaltyOtpStatusApi = (params) =>
  api.get(`/loyalty/redeem-otp/status/${encodeURIComponent(params.phone_e164)}`);

// Redeem itself — phone-keyed + OTP-gated.
export const loyaltyRedeemApi = (params) =>
  api.post(`/loyalty/redeem`, JSON.stringify(params));

export const loyaltyRedeemReverseApi = (params) =>
  api.post(`/loyalty/redeem/reverse`, JSON.stringify(params));

export const loyaltyAdjustApi = (params) =>
  api.post(`/loyalty/members/adjust`, JSON.stringify(params));

export const loyaltyEnrolApi = (params) =>
  api.post(`/loyalty/members/enrol`, JSON.stringify(params));

export const loyaltyRuntimeApi = () => api.get(`/loyalty/runtime-config`);
